import React, { FC } from 'react';
import { Container } from '../../components/base/grid';
import { H1 } from '../../components/base/typography';
import Breadcrumbs from '../../components/breadcrumbs';
import CompanyDebitComponent from '../../components/companyDebitForm';
import pageWrapper from '../../hoc/pageWrapper';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';

interface Props {
	componentId: number;
	page: IPageViewModel;
}

const CompanyDebitForm: FC<Props> = ({ page }) => {
	return (
		<Container>
			<Breadcrumbs pageId={page.Id} />
			<H1 marginTop="4rem" marginBottom="4rem">
				{page.Name}
			</H1>
			<CompanyDebitComponent />
		</Container>
	);
};

export default pageWrapper(CompanyDebitForm);
